var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"neo-console"},[_c('ul',_vm._l((_vm.messages),function(message,i){return _c('li',{key:i},[_c('NeoInput',{attrs:{"message":message,"delay":3000},on:{"submit":_vm.push}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }